import React from 'react';
import classNames from 'classnames';
import Icon from '../common/Icon';

const ItemButton = ({
  visible,
  className,
  icon = 'chevron-right-regular',
  ...props
}) =>
  visible && (
    <button
      {...props}
      type="button"
      className={classNames('nav__itemButton', className)}
    >
      <Icon name={icon} />
    </button>
  );

const Link = ({ title, children, active, ...props }) => (
  <a
    {...props}
    className={classNames('nav__link', { '-active': active }, props.className)}
  >
    {title}
    {children}
  </a>
);

const NavItem = ({
  title,
  link,
  isActive,
  isDescendantActive,
  className,
  children,
  buttonClickHandler,
  nested,
  small,
  hideChildren = false,
  before = () => { },
  ...props
}) => (
  <li
    {...props}
    className={classNames('nav__item', className, { '-nested': nested })}
  >
    {before()}
    <Link
      href={link}
      active={isActive || isDescendantActive}
      title={title}
      className={classNames({ '-tiny': small })}
    />
    <ItemButton
      visible={!hideChildren && !!children.length}
      onClick={buttonClickHandler}
    />
  </li>
);

export default NavItem;
